import Vue from 'vue'
import VueRouter from 'vue-router'
// import ClinicCoupons from "./pages/ClinicCoupons"
import MembershipSubscription from "./pages/MembershipSubscription.vue"
import MembershipCharge from "./pages/MembershipCharge"
import ParentReport from "./pages/parent_report"
import PageNotFound from "./pages/PageNotFound"
import SaleManagers from "./pages/SaleManagers"
import Analytics from "./pages/sale_managers/Analytics"
// import MenuCoupons from "./pages/MenuCoupons"
import ManagerMenuCoupons from "./pages/manager/MenuCoupons"
import OwnerMenuCoupons from "./pages/owner/MenuCoupons"
import OwnerClinicCoupons from "./pages/owner/ClinicCoupons"
import Permalink from './pages/permalink/Permalink';
import BookingEdit from './pages/booking/Edit';
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/owner/clinic_coupons',
      name: 'OwnerClinicCoupons',
      component: OwnerClinicCoupons
    },
    {
      path: '/owner/points/membership_subscriptions',
      name: 'MembershipSubscription',
      component: MembershipSubscription
    },
    {
      path: '/owner/points/membership_charges',
      name: 'MembershipCharges',
      component: MembershipCharge
    },
    {
      path: '/owner/parent_reports',
      name: 'ParentReport',
      component: ParentReport
    },
    {
      path: '/owner/sale_managers/analytics',
      name: 'Analytics',
      component: Analytics
    },
    {
      path: '/owner/menu_coupons',
      name: 'OwnerMenuCoupons',
      component: OwnerMenuCoupons
    },

    {
      path: '/manager/menu_coupons',
      name: 'ManagerMenuCoupons',
      component: ManagerMenuCoupons
    },

    {
      path: '/booking/:permalink',
      name: 'Permalink',
      component: Permalink
    },
    {
      path: '/bookings/:id/edit',
      name: 'BookingEdit',
      component: BookingEdit
    },
    { path: "*", component: PageNotFound }
  ]
})

router.afterEach((to, from) => {
  // console.log(to.meta.openKey)
})

export default router
